let mfLegacyGiftCleanupRunning = false;

const mfRefreshCartDrawer = (state) => {
  const drawer = document.querySelector('cart-drawer');

  if (drawer?.renderContents) {
    drawer.renderContents(state);
  }

  document.dispatchEvent(new CustomEvent('cart:updated', {
    detail: { cart: state },
  }));
};

const mfRemoveLegacyGift = async () => {
  const drawer = document.querySelector('cart-drawer');
  const lineKey = drawer?.dataset.mfPaidGiftLineKey;

  if (!drawer || !lineKey || mfLegacyGiftCleanupRunning) return;

  mfLegacyGiftCleanupRunning = true;

  try {
    const sections = drawer.getSectionsToRender?.().map((section) => section.id) || [];
    const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        updates: { [lineKey]: 0 },
        attributes: { mf_gift_of_fate_choice: '' },
        sections,
        sections_url: window.location.pathname,
      }),
    });
    const state = await response.json();

    if (!response.ok || state.status) {
      throw new Error(state.description || state.message || 'Unable to remove the retired gift item.');
    }

    mfRefreshCartDrawer(state);
  } catch (error) {
    console.error('[Mantra Flow cart] Legacy gift cleanup failed:', error);
  } finally {
    mfLegacyGiftCleanupRunning = false;
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mfRemoveLegacyGift, { once: true });
} else {
  mfRemoveLegacyGift();
}

document.addEventListener('cart:updated', () => {
  window.setTimeout(mfRemoveLegacyGift, 0);
});
